/** Where the supplier's activation email would be routed. */
export const ACTIVATION_ROUTING_VERDICT = ['direct', 'cs'] as const;

export const ACTIVATION_ROUTING_REASONS = [
  'supplier_routing_rules',
  'no_registered_contact',
  'account_flag',
] as const;

/** The document types this diagnosis judges independently. */
export const ACTIVATION_ROUTING_DOCUMENT_TYPES = ['dln', 'invoice'] as const;

export const ACTIVATION_ROUTING_CONDITION_KEYS = [
  'dln_contact',
  'dln_format',
  'dln_incoming_channel',
  'inv_format',
  'invoice_contact',
  'special_cases',
  'unlock_details',
] as const;
